import { useAppStore } from "../../../../GlobalStore/GlobalStore";
import { useContext } from "react";
import { GlobalContext } from "../../../../App";
import stop from '../../../../assets/stop.svg';

const StopRecording = () => {
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;
    const { stopRecordingHelper } = useContext(GlobalContext);

    const handleStopClick = () => {
        stopRecordingHelper();
    };

    const buttonDimensions = environment === "vscode" ? "h-7 w-7" : "h-8 w-8";

    return (
        <button onClick={handleStopClick}>
            <img
                src={`${stop}`}
                alt="Stop Recording"
                className={`${buttonDimensions} cursor-pointer`}
            />
        </button>
    );
};

export default StopRecording;